import { createContext, useContext } from "react"
import type { Moment } from "moment"

export type RangeTuple = [Moment | null, Moment | null]

export type RangeSelectionContextValue = {
  range: RangeTuple
  hover: Moment | null
  setHover: (d: Moment | null) => void
}

const noop = () => {}

const defaultValue: RangeSelectionContextValue = {
  range: [null, null],
  hover: null,
  setHover: noop
}

export const RangeSelectionContext = createContext<RangeSelectionContextValue>(defaultValue)

export function useRangeSelectionContext() {
  return useContext(RangeSelectionContext)
}
